export const brandColors = {
  brandOne: '#005950',
  brandTwo: '#C4541D',
  brandThree: '#D2B470',
} as const;
